import { InjectionToken } from '@angular/core';

export interface TranslationConfig {
  prefix: string;
  suffix: string;
}

export const TRANSLATION_CONFIG =
  new InjectionToken<TranslationConfig>('TRANSLATION_CONFIG');
